/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getExampleAudioCachedV1ResultSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({
    exists: z.literal(true),
    value: z.object({
      audioUrl: z.string(),
      wordTimings: z.array(wordTimingSchema).optional(),
    }),
  }),
]);

export type IGetExampleAudioCachedV1Result = z.infer<typeof getExampleAudioCachedV1ResultSchema>;

export const getExampleAudioCachedV1ResponseSchema = createApiResponseSchema(
  getExampleAudioCachedV1ResultSchema,
) as z.ZodSchema<IAPI<IGetExampleAudioCachedV1Result>>;

export type IGetExampleAudioCachedV1Response = IAPI<IGetExampleAudioCachedV1Result>;
